export { default } from "./useStudentPowerWordQuizGet";
